import { useMemo } from 'react';

import { TypedPolicy } from '../../../types';

import {
  AUTOMATIC_NAMESPACE_PROVISIONING_INITIAL_VALUES,
  AutomaticNamespaceProvisioningFormValues,
  AutomaticNamespaceProvisioningPolicyPayload,
} from './types';

export function useAutomaticNamespaceProvisioningInitialValues(
  policy?: TypedPolicy<unknown>
): AutomaticNamespaceProvisioningFormValues {
  return useMemo(() => getInitialValuesFromPolicy(policy), [policy]);
}

function getInitialValuesFromPolicy(
  policy?: TypedPolicy<unknown>
): AutomaticNamespaceProvisioningFormValues {
  if (!policy) {
    return AUTOMATIC_NAMESPACE_PROVISIONING_INITIAL_VALUES;
  }

  const base = {
    name: policy.Name || '',
    environmentGroupIds: policy.EnvironmentGroups || [],
  };

  if (!isAutomaticNamespaceProvisioningPolicyPayload(policy.Data)) {
    return { ...AUTOMATIC_NAMESPACE_PROVISIONING_INITIAL_VALUES, ...base };
  }

  return {
    ...base,
    userScopes: policy.Data.UserScopes,
    namespacePattern: policy.Data.NamespacePattern,
    namespaceRoleId: policy.Data.NamespaceRoleID,
  };
}

function isAutomaticNamespaceProvisioningPolicyPayload(
  data: unknown
): data is AutomaticNamespaceProvisioningPolicyPayload {
  return (
    typeof data === 'object' &&
    data !== null &&
    'UserScopes' in data &&
    Array.isArray(data.UserScopes) &&
    'NamespacePattern' in data &&
    typeof data.NamespacePattern === 'string' &&
    'NamespaceRoleID' in data &&
    typeof data.NamespaceRoleID === 'number'
  );
}
